import React, { FunctionComponent, useState } from 'react'
import { FaSlack } from 'react-icons/fa'
import Dialog from '@material-ui/core/Dialog'
import moment from 'moment'

import '../styles/Item.scss'
import { SlackData } from '../utils/SearchItem'
import Icon from './Icon'
import MatchingTerms from './MatchingTerms'

const SlackItem: FunctionComponent<SlackData> = (props) => {
  const [open, toggleOpen] = useState(false)

  const renderPopup = () => {
    const date = moment(new Date(props.timestamp)).format(
      'h:mm A • MMM D, YYYY'
    )
    return (
      <Dialog open={open} onClose={() => toggleOpen(false)}>
        <div className='Item-popup'>
          <div className='Item-popup-header'>
            <Icon icon={FaSlack} backgroundColor='#b3e1f8' />
            <p>{props.message}</p>
          </div>
          <div className='Item-popup-content'>
            <strong>
              <p>Author: </p>
            </strong>
            <p>@{props.author}</p>
            <strong>
              <p>Full message: </p>
            </strong>
            <p>"{props.message}"</p>
            <strong>
              <p>Channel: </p>
            </strong>
            <p>#{props.channel}</p>
            <strong>
              <p>Timestamp: </p>
            </strong>
            <p>{date}</p>
          </div>
          <MatchingTerms
            backgroundColor='#b3e1f8'
            terms={props.matching_terms}
          />
        </div>
      </Dialog>
    )
  }

  return (
    <>
      <div className='Item' onClick={() => toggleOpen(true)}>
        <Icon icon={FaSlack} backgroundColor='#b3e1f8' />
        <p>{props.message}</p>
      </div>
      {renderPopup()}
    </>
  )
}

export default SlackItem
